import React from "react";

const SeatSvg = ({ backgroundColor = '#34C759' }) => {
    return (
      <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 128 128"
      stroke="transparent"
    >
      <defs>
        <style>
          {`.cls-1{fill:none;}.cls-2{stroke:transparent;stroke-miterlimit:10;}`}
        </style>
        <clipPath id="clip-path">
          <rect className="cls-1" x="4.94" y="79.49" width="58.62" height="41.52" />
        </clipPath>
        <clipPath id="clip-path-2">
          <rect className="cls-1" x="63.56" y="79.49" width="58.62" height="41.52" />
        </clipPath>
      </defs>
      {/* Ajuste dinámico del color de fondo */}
      <rect
        style={{ fill: backgroundColor }}
        className="cls-2"
        x="18.81"
        y="9.5"
        width="89.5"
        height="83.5"
        rx="12.13"
      />
      <g id="_Repetición_de_espejo_" data-name="&lt;Repetición de espejo&gt;">
        <g className="cls-3">
          <path
            style={{ fill: backgroundColor }}
            className="cls-2"
            d="M65.93,111.64c-.26-2.87-.89-5.71-1.4-8.56-14.94.66-29.6-2.3-40.19-9-10-6.32-14.15-15.26-17.06-14C4,81.56,5,94.27,11,102.66c9.1,12.59,32.09,18.7,54.84,17.76C65.73,117.49,66.19,114.57,65.93,111.64Z"
          />
        </g>
      </g>
      <g id="_Repetición_de_espejo_2" data-name="&lt;Repetición de espejo&gt;">
        <g className="cls-4">
          <path
            style={{ fill: backgroundColor }}
            className="cls-2"
            d="M61.2,111.64c.26-2.87.88-5.71,1.39-8.56,15,.66,29.6-2.3,40.2-9,10-6.32,14.14-15.26,17.06-14,3.24,1.44,2.31,14.15-3.76,22.54C107,115.25,84,121.36,61.26,120.42,61.39,117.49,60.93,114.57,61.2,111.64Z"
          />
        </g>
      </g>
    </svg>
    );
};

export default SeatSvg;
